/*
 * @Descripttion: 育儿日历接口
 * @Author: Niu Chenxin
 * @Date: 2021-02-18 10:23:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-26 17:39:59
 */
import Http from "./../http";

export default {
  // 获取所有日历列表
  getCalendarList(urlParams, params, callback) {
    Http.post("/parentingCalendar/getCalendarList", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取连续签到天数以及签到状态
  getSignDays(params, callback) {
    Http.get("/taskEventController/checkin/detail", params, res => {
      callback(res);
    }, err => {}, "member")
  },
  // 点击签到
  sign(params, callback) {
    Http.get("/taskEventController/checkin/sign", params, res => {
      callback(res);
    }, err => {}, "member")
  },
  // 分享
  addShare(urlParams, params, callback) {
    Http.post("/parentingCalendar/addShare", urlParams, params, res => {
      callback(res);
    })
  },
  // 点赞
  addLike(urlParams, params, callback) {
    Http.post("/parentingCalendar/addLike", urlParams, params, res => {
      callback(res);
    })
  },
  // 取消点赞
  cancelLike(urlParams, params, callback) {
    Http.post("/parentingCalendar/cancelLike", urlParams, params, res => {
      callback(res);
    })
  },
  // 收藏
  addCollect(urlParams, params, callback) {
    Http.post("/parentingCalendar/addCollect", urlParams, params, res => {
      callback(res);
    })
  },
  // 取消收藏
  cancelCollect(urlParams, params, callback) {
    Http.post("/parentingCalendar/cancelCollect", urlParams, params, res => {
      callback(res);
    })
  },
  // 获取收藏页日历列表
  getCollectByCalendar(urlParams, params, callback) {
    Http.post("/parentingCalendar/getCollectByCalendar", urlParams, params, res => {
      callback(res);
    })
  }
}